<template>
  <div class="findlaw_pfzs">
    <sec-title class="text_center" Text="普法知识" />
    <!-- <div class="cont between">
      <div class="new_le">
        <div>
          <img
            class="img"
            src="../../../assets/findlawyers/switem.png"
            alt=""
          />
        </div>
        <div class="tit ellipsis">工地老板拖欠工资怎么办 没签合同的</div>
        <div class="des">
          {{
            `在现实生活中，很多农民工在建筑工地从事建筑行业的工作，而拖欠农民工工资的情况是比较普遍的的工作，而拖欠农民工工资的情况是比较普遍的`
              | toEllipsisFilter(80)
          }}
        </div>
        <div class="tag"><span>劳动纠纷</span> 2021-03-30</div>
      </div>
      <div class="new_rlist">
        <div class="rl_item" v-for="(item, index) in 4" :key="index">
          <div class="tit ellipsis">工地老板拖欠工资怎么办 没签合同的</div>
          <div class="des">
            {{
              `在现实生活中，很多农民工在建筑工地从事建筑行业的工作，而拖欠农民工工资的情况是比较普遍的的工作，而拖欠农民工工资的情况是比较普遍的`
                | toEllipsisFilter(70)
            }}
          </div>
          <div class="tag"><span>劳动纠纷</span> 2021-03-30</div>
        </div>
      </div>
    </div> -->
	<div class="new_rlist flex between wrap">
	  <div class="rl_item flex " v-for="(item, index) in 4" :key="index">
		  <img src="../../../assets/lawyerOnline/ttlaw_sample.png" style="width: 160px; height: 110px;">
	    <div class="ml20">
	    	<div class="tit ellipsis">工地老板拖欠工资怎么办 没签合同的</div>
	    	<div class="des">
	    	  {{
	    	    `在现实生活中，很多农民工在建筑工地从事建筑行业的工作，而拖欠农民工工资的情况是比较普遍的的工作，而拖欠农民工工资的情况是比较普遍的`
	    	      | toEllipsisFilter(70)
	    	  }}
	    	</div>
	    </div>
	  </div>
	</div>
	
	
	<!-- 便民工具 -->
	<!-- <div class="tool">
		<span class="FontSize22 FontBlack">便民工具</span>
		<div class="toollist">
			<div class="toolitem">
				
			</div>
		</div>
	</div> -->
  </div>
</template>

<script>
import secTitle from "views/home/components/secTitle";
import qestlawfirmlist from "../components/qestlawfirmlist";
export default {
  components: {
    secTitle,
    qestlawfirmlist,
  },
};
</script>

<style lang="scss" scope>
.findlaw_pfzs {
  width: 1200px;
  margin: 0 auto;
  padding: 50px 0;
  .new_rlist {
    width: 100%;
    padding-top: 5px;
    .rl_item {
		width: 49%;
      margin-bottom: 38px;
	  padding: 12px 33px 0 5px;
        cursor: pointer;
		background: #FFFFFF;
		box-shadow: 0px 3px 7px 0px rgba(0, 0, 0, 0.1);
		align-items: center;
      &:hover {
        .tit {
          color: #0465ea;
        }
      }
      .tit {
        font-size: 20px;
        color: #333333;
      }
      .des {
        margin: 14px 0;
        font-size: 16px;
        color: #666666;
        line-height: 26px;
      }
      .tag {
        display: inline-block;
        font-size: 16px;
        color: #999999;
        span {
          padding-right: 10px;
          border-right: 1px solid #999999;
          margin-right: 10px;
        }
      }
    }
  }
}
</style>